import { ListSubheader } from '@mui/material'
import useBulkActionCounts from './useBulkActionCounts'

export default function BulkActionsSubheader({
  isTableField,
  tableFieldName,
  displayCount,
}: ReturnType<typeof useBulkActionCounts>) {
  const label = isTableField
    ? `${displayCount} ${tableFieldName} Row${
        displayCount === 1 ? '' : 's'
      } Selected`
    : `${displayCount} Document${displayCount === 1 ? '' : 's'} Selected`

  return (
    <ListSubheader
      sx={{
        backgroundColor: 'transparent',
        lineHeight: '32px',
        fontSize: '0.75rem',
      }}
    >
      {label}
    </ListSubheader>
  )
}
